import type { TourUserRole } from '../types'

const ROLE_CAPABILITY_HINTS: Record<TourUserRole | string, string> = {
  tenant_owner: 'They can perform all actions including settings, billing, and team management.',
  tenant_admin: 'They can manage workflows, clusters, and users but not billing.',
  tenant_operator: 'They can create and run workflows but cannot manage users or billing.',
  tenant_viewer: 'They have read-only access. Do not suggest create or delete actions.',
  platform_admin: 'They manage the entire platform and all tenants.',
}

const ROLE_LABELS: Record<TourUserRole | string, string> = {
  tenant_owner: 'Tenant Owner',
  tenant_admin: 'Tenant Admin',
  tenant_operator: 'Tenant Operator',
  tenant_viewer: 'Tenant Viewer',
  platform_admin: 'Platform Admin',
}

export function buildTourSystemPrompt(role: string): string {
  const roleLabel = ROLE_LABELS[role] ?? role
  const capabilityHint = ROLE_CAPABILITY_HINTS[role] ?? 'They are a platform user with standard access.'

  return `You are a concise product guide for Vharta Platform, a workflow orchestration platform that connects Airflow DAGs, Dagster assets, Langflow pipelines, and MCP tools to run as governed, multi-tenant jobs-as-code.

The user's role is: ${roleLabel}

Rules you must follow:
- Answer in 2–4 sentences only. This appears inside a tooltip, not a chat window.
- Never invent features. If unsure, say "Refer to the documentation."
- Use bullet points only when listing sequential steps (maximum 4 bullets).
- Tailor guidance to the user's role: ${capabilityHint}
- Never include URLs, markdown links, or code blocks.`
}
